import axios from 'axios'

const state = {
  user: localStorage.getItem('user-name') || '',
  token: localStorage.getItem('user-token') || '',
  expiration: localStorage.getItem('token-expiration') || '',
  status: ''
}

const getters = {
  isAuthenticated: state => !!state.token,
  userAuthenticated: state => state.user,
  authStatus: state => state.status
}
const actions = {
  authRequest ({commit, dispatch}, data) {
    return new Promise((resolve, reject) => { // Promise pour la redirection après accès autorisé
      commit('setRequest')
      axios.post('api/auth', data)
        .then(resp => {
          const token = resp.data.jwt
          const expiration = resp.data.exp
           // Token et User conservé dans localStorage en cas de raffraichissement de la page
          localStorage.setItem('user-name', data.username)
          localStorage.setItem('user-token', token)
          localStorage.setItem('token-expiration', expiration)
          commit('setSuccess', resp)
          resolve(resp)
        })
      .catch(error => {
        commit('setError', error)
        dispatch('authLogout')
        reject(error)
      })
    })
  },
  authLogout ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      commit('setLogout')
      localStorage.removeItem('user-name')
      localStorage.removeItem('user-token')
      localStorage.removeItem('token-expiration')
      // supprimer le header d'authentification de l'api
      axios.delete('/api/auth')
      resolve()
    })
  },
  checkAuthStatus ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      const expirationTime = localStorage.getItem('token-expiration')
      var currentTime = new Date().getTime() / 1000
      if (currentTime > expirationTime) {
        dispatch('authLogout')
      }

      resolve()
    })
  }
}

const mutations = {
  setRequest: (state) => {
    state.status = 'loading'
  },
  setSuccess: (state, token) => {
    state.status = 'success'
    state.token = token.data.jwt
    axios.defaults.headers.common['Authorization'] = 'Bearer' + state.token
    console.log(axios.defaults.headers)
  },
  setError: (state) => {
    state.status = 'error'
    state.token = ''
  },
  setLogout: (state) => {
    state.token = ''
    state.status = ''
    state.user = ''
    axios.defaults.headers.common['Authorization'] = ''
  },
  setAuthHeader: (state) => {
    const token = localStorage.getItem('user-token')
    if (token) { // ajouter if token is valid sinon deconnecté l'utilisateur
      state.status = 'success'
      axios.defaults.headers.common['Authorization'] = 'Bearer' + token
    }
  },
  setInterceptor: (state) => {
    axios.interceptors.response.use(undefined, function (error) {
      if (error.status === 401 && error.status === 400 && error.config && !error.config.__isRetryRequest) {
        this.$store.dispatch('authLogout')
      }
      throw error
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/auth.js